import { UtilityText } from '@leagueplatform/genesis-core';
import React from 'react';
import { useShallow } from 'zustand/react/shallow';
import Fields from './tobacco-use.fields.component';
import { useTobaccoStore } from '../store/tobacco-use.form-store';
import TobaccoUsageLabel from '../tobacco-use-labels.json';

function Dependent(props: any) {
  const { dependentsKey } = props;
  const dependent = useTobaccoStore((state) => state.dependents[dependentsKey]);
  return <Fields tobaccoUser={dependent} dependentsKey={dependentsKey} />;
}

function Dependents() {
  const dependentsKeys = useTobaccoStore(
    useShallow((state) => Object.keys(state.dependents)),
  );

  const dependentSection = dependentsKeys.map((dependents_key) => (
    <Dependent key={dependents_key} dependentsKey={dependents_key} />
  ));

  if (dependentSection.length === 0) {
    return null;
  }

  return (
    <>
      <UtilityText
        emphasis="emphasized"
        css={{ marginBottom: '-18px !important' }}
      >
        {TobaccoUsageLabel.labels.regular_user_dependents}
      </UtilityText>
      {dependentSection}
    </>
  );
}

export default Dependents;
